module.exports = ".tags-input .inputs {\r\n  display: flex;\r\n}\r\n\r\n.tags-input .inputs i {\r\n  font-size: 20px;\r\n  cursor: pointer;\r\n}\r\n"